import { api, defaultQueriesFor } from '../apiSlice';

export const cateringRequestApi = api
  .enhanceEndpoints({ addTagTypes: ['CateringRequest'] })
  .injectEndpoints({
    endpoints: build => ({
      ...defaultQueriesFor(build, 'CateringRequest', 'CateringRequests', true),

      getCateringRequestWithParams: build.query({
        query: ({ id, ...params }) => {
          const queryString = new URLSearchParams(params).toString();
          return `/catering_requests/${id}${queryString ? `?${queryString}` : ''}`;
        },
        providesTags: ['CateringRequest']
      }),

      closeCateringRequest: build.mutation({
        query: ({ id, truckId }) => ({
          url: `/catering_requests/${id}/close`,
          method: 'POST',
          body: { truck_id: truckId },
        }),
        invalidatesTags: ['CateringRequest'],
      }),

      reopenCateringRequest: build.mutation({
        query: (id) => ({
          url: `/catering_requests/${id}/reopen`,
          method: 'POST',
        }),
        invalidatesTags: ['CateringRequest'],
      }),

      hideBid: build.mutation({
        query: ({ id, ...options }) => ({
          url: `/catering_requests/${id}/hide_bid`,
          method: 'POST',
          body: options,
        }),
        invalidatesTags: ['CateringRequest', 'Bid'],
      }),

      unhideBid: build.mutation({
        query: ({ id, ...options }) => ({
          url: `/catering_requests/${id}/unhide_bid`,
          method: 'POST',
          body: options,
        }),
        invalidatesTags: ['CateringRequest', 'Bid'],
      }),

      favoriteBid: build.mutation({
        query: ({ id, ...options }) => ({
          url: `/catering_requests/${id}/favorite_bid`,
          method: 'POST',
          body: options,
        }),
        invalidatesTags: ['CateringRequest', 'Bid'],
      }),

      unfavoriteBid: build.mutation({
        query: ({ id, ...options }) => ({
          url: `/catering_requests/${id}/unfavorite_bid`,
          method: 'POST',
          body: options,
        }),
        invalidatesTags: ['CateringRequest', 'Bid'],
      }),

      createBid: build.mutation({
        query: ({ id, ...options }) => ({
          url: `/catering_requests/${id}/create_bid`,
          method: 'POST',
          body: options,
        }),
        invalidatesTags: ['CateringRequest', 'Bid'],
      }),

      updateBid: build.mutation({
        query: ({ id, ...options }) => ({
          url: `/catering_requests/${id}/update_bid`,
          method: 'POST',
          body: options,
        }),
        invalidatesTags: ['CateringRequest', 'Bid'],
      }),

      hideForTruck: build.mutation({
        query: ({ id, ...options }) => ({
          url: `/catering_requests/${id}/hide_request`,
          method: 'POST',
          body: options,
        }),
        invalidatesTags: ['CateringRequest', 'Bid'],
      }),

      unhideForTruck: build.mutation({
        query: ({ id, ...options }) => ({
          url: `/catering_requests/${id}/unhide_request`,
          method: 'POST',
          body: options,
        }),
        invalidatesTags: ['CateringRequest', 'Bid'],
      }),

    }),
  });

export const {
  useCloseCateringRequestMutation,
  useCreateBidMutation,
  useCreateCateringRequestMutation,
  useDeleteCateringRequestMutation,
  useFavoriteBidMutation,
  useGetCateringRequestByIdQuery,
  useGetCateringRequestsQuery,
  useGetCateringRequestWithParamsQuery,
  useHideBidMutation,
  useHideForTruckMutation,
  useReopenCateringRequestMutation,
  useUnfavoriteBidMutation,
  useUnhideBidMutation,
  useUnhideForTruckMutation,
  useUpdateBidMutation,
  useUpdateCateringRequestMutation,
} = cateringRequestApi;
